import { Component, OnInit ,Input, Output, EventEmitter} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { fciWebsiteService } from '../../service/fci-website.service';
import { CustomServiceService } from '../../service/custom-service.service';
import {  EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';

import { environment } from 'src/environments/environment'; 
declare let $: any;
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';
 
@Component({
  selector: 'app-circular-details',
  templateUrl: './circular-details.component.html',
  styleUrls: ['./circular-details.component.css']
})
export class CircularDetailsComponent implements OnInit { 

  constructor(private httpservice: CustomServiceService,private fciwebservice: fciWebsiteService, private routerparam: ActivatedRoute, private encDec: EncryptDecryptService) { } 

  circular_id:any="";
  language:any = "";
  ngOnInit(): void {
    this.language = sessionStorage.getItem('locale');//dynamic
    this.getDivision();
  this.circular_id = this.encDec.decText(this.routerparam.snapshot.paramMap.get('id'));
  this.getDetails(this.circular_id);
  }
  backend_url: any = environment.serviceURL;
  apirespons: any;
  circular_Details: any = {
    "sINo": '',
    "mediaType": '',
    "awardNumber": "",
    "zone": '',
    "region": '',
    "division": '',
    "title": "",
    "title(Hindi)": "",
    "publishDate": "",
    "achieveDate": "",
    "sourceURL": "",
    "uploadImage": "",
    "uploadDocument": "",
    "description": "",
    "description(Hindi)": "",
    "jsonOptTxtDetails": "",
    "id":"",
    "uploadImage_details": {
        "fileType": "",
        "fileSize": ""
    },
    "uploadDocument_details": {
        "fileType": "",
        "fileSize": ""
    }
};
  getDetails(tid:any) {
    let params = [
      {
        "secSlNo": 1,
        "offSet": 0,
        "noOfRecords": 0,
        "orderBy": [],//{ "columnName": "VCHMENUNAME", "type": "asc" }
        "condition": [
          { "columnName": "tinPublishStatus", "operator": "=", "value": "1", "joinoperator": "and" },
          { "columnName": "bitDeletedFlag", "operator": "=", "value": "0", "joinoperator": "and" },
          { "columnName": "intId", "operator": "=", "value": tid, "joinoperator": "and" }
        ], 
        "viewParameters": ""
      }];
    this.httpservice.getCircular(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.apirespons = response.body;
          let respData = this.apirespons.RESPONSE_DATA;
          let respToken = this.apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response: any = Buffer.from(respData, 'base64');
            response = JSON.parse(response);
            let data = response.result.sec_1;
            if(data.length > 0){
              this.circular_Details = response.result.sec_1[0];
            } 
          } 
      }
    });
  }

  

  jsonConvert(data: any, type: any) {
    if(data==null || data==""){
      return "";
    }
    if(data.jsonOptTxtDetails=="" || data.jsonOptTxtDetails==null){
      return "";
    }
    let d = JSON.parse(data.jsonOptTxtDetails);
    if (type == 'ZONE_ID') {
      return d.ZONE_ID;
    } else if (type == 'LINK_ID') {
      return d.LINK_ID;
    } else if (type == 'REGION_ID') {
      return d.REGION_ID;
    } else {
      return '';
    }
  }

htmlTag(data:any){
  return this.encDec.decodeHtml(data);
}

checkFileExists(obj:any):boolean{
  if(obj.uploadDocument==""){
    return false;
  }
  if(obj.uploadDocument_details==undefined){
    return false;
   }
  if(obj.uploadDocument_details.fileSize==undefined){
    return false;
   }
 if(obj.uploadDocument_details.fileSize==""){
  return false;
 }
return true;
}

division_apirespons: any;
divisionList:any[]=[]; 

getDivision() {
  var query:any=[
    {"columnName":"tinPublishStatus","operator":"=","value":"1","joinoperator":"and"},
    {"columnName":"bitDeletedFlag","operator":"=","value":0,"joinoperator":"and"},
    { "columnName": "DIVISION_TYPE", "operator": "in", "value": '2,4', "joinoperator": "and" }
];
// if(environment.ZONE_ID  > 0){
//     query.push({ "columnName": "ZONE_ID", "operator": "=", "value": environment.ZONE_ID, "joinoperator": "and" });
// }
  let params = [{
    "secSlNo":1,
    "offSet":0,  
    "noOfRecords":0,
    "orderBy":[{"columnName":"VCHDIVISIONEN","type":"ASC"}],
    "condition":query, 
    "viewParameters":""
 }];
  this.httpservice.getDivisionList(params).subscribe((response: HttpEvent<any>) => {
    switch (response.type) {
      case HttpEventType.Sent:
        break;
      case HttpEventType.ResponseHeader:
        break; 
      case HttpEventType.UploadProgress:
        //this.evenTotal = response.total;
        //this.progress = Math.round(response.loaded / this.evenTotal * 100);
        break;
      case HttpEventType.Response:
        this.division_apirespons = response.body;
        let respData = this.division_apirespons.RESPONSE_DATA;
        let respToken = this.division_apirespons.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
        if (respToken == verifyToken) {
          let res = JSON.parse(Buffer.from(respData, 'base64').toString());
          if(res.status==200){
             this.divisionList = res.result.sec_1;
          }
        }
    }
})
}


getDivisionName(data: any):string {
  let d='';
  this.divisionList.forEach((element:any) => {       
    if(element.id==data.chooseDivision){
      if(this.language=='English'){
         d= this.htmlTag(element.name);
      } else{
         d= this.htmlTag(element.nameInHindi);
       }
    }


   
  });

  return d;

  // const jsonOptTxtDetails = JSON.parse(data.jsonOptTxtDetails);
  // return jsonOptTxtDetails.INTCIRCULARDIV;
}

checkFileType(data:any):any{
  let ext:any,fileType:any;
  ext= ['webp','jpeg', 'jpe', 'png', 'gif', 'jpg', 'pdf', 'PNG','xlsx','xls','csv','docx','doc'];
  if(data==""){
    return false; 
  }  
  if(data.uploadDocument==""){
    return false; 
  }
  if(data.uploadDocument_details==undefined){
    return false; 
  }
  if(data.uploadDocument_details.fileType==undefined){
    return false; 
  }
  if(data.uploadDocument_details.fileType==''){
    return false; 
  }
  fileType=data.uploadDocument_details.fileType.toLowerCase();
  if(fileType=='xlsx' || fileType=='xls' || fileType=='csv'){
    return {'fileType':fileType,'file': `|| <i class="fa fa-file-excel-o" aria-hidden="true"></i> ${fileType} || `}; 
  } else if(fileType=='docx' || fileType=='doc'){
    return {'fileType':fileType,'file':`|| <i class="fa fa-file-word-o" aria-hidden="true"></i> ${fileType} || `}; 
  } else if(fileType=='pdf'){
    return {'fileType':fileType,'file':`|| <i class="fa fa-file-pdf-o" aria-hidden="true"></i> ${fileType} || `}; 
  } else {
    return {'fileType':fileType,'file':`|| <i class="fa fa-file-text" aria-hidden="true"></i> ${fileType} || `}; 
  }
}



}
